import './plugins/mmenu.js';

// mmenu configuration for mobile nav
Mmenu.configs.offCanvas.page.selector = '#shell';

document.addEventListener('DOMContentLoaded', () => {
    new Mmenu('#mobile-menu', {
        slidingSubmenus: true,
    });
});

// Enable HMR for Vite
if (import.meta.hot) {
    import.meta.hot.accept();
}
